import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { take, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiRequest = request.url.startsWith(environment.apiUrl);
    const shouldForceJsonAccept =
      isApiRequest &&
      request.responseType === 'json' &&
      !request.headers.has('Accept');

    if (shouldForceJsonAccept) {
      request = request.clone({
        setHeaders: {
          Accept: 'application/json',
        },
      });
    }

    if (
      request.headers.has('skip-auth') &&
      request.headers.get('skip-auth') === 'true'
    ) {
      return next.handle(request);
    }

    return this.authService.currentUser$.pipe(
      take(1),
      switchMap((user) => {
        if (user) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${user.token}`,
            },
          });
        }
        return next.handle(request);
      }),
    );
  }
}
